export const REDIRECT_LOGOUT_KEY = 'RESERVAMOS_REDIRECT_SSO_LOGOUT_KEY';
export const REDIRECT_LOGIN_KEY = 'RESERVAMOS_REDIRECT_SSO_LOGIN_KEY';
